module.exports = __webpack_public_path__ + "02b2a8b12a48b9ca49e2444ec714f54d.pdf";